import { Box3, Vector2Tuple, Vector3 } from 'three';

import { FCompositionNodeImpl } from '../nodes/index.js';
import { FNode, FNodeTypesEnum, FurnitureNode } from '../types/index.js';

const _center = new Vector3();
const _size = new Vector3();
export const boxFromNode = (node: FNode, target: Box3): { box: Box3; success: boolean } => {
  let success = false;
  if (node.type === FNodeTypesEnum.FComposition) {
    const cNode = node as FCompositionNodeImpl;
    if (cNode.instance?.has('size')) {
      // farrangement nodes, use size attribute
      const size: Vector2Tuple = cNode.instance.getValue('size');

      target.setFromCenterAndSize(
        _center.set(node.position[0], 0, node.position[1]),
        _size.set(size[0], 0, size[1])
      );
      success = true;
    } else {
      // fensembles, calculate bounding box
      try {
        cNode.instance.computeBoundingBox();
        target.copy(cNode.instance.boundingBox!);
        success = true;
      } catch (e) {
        console.warn(`Failed to calculate bounding box for Fensemble. ${(e as Error).message}`);
      }
    }
  } else if (node.type === FNodeTypesEnum.Furniture || node.type === FNodeTypesEnum.Decoration) {
    // furnitures - aleady collider has the bounding box calculated
    const cNode = node as FurnitureNode;
    target.copy(cNode.collider!.box);
    success = true;
  }
  return { box: target, success };
};
